'use client';

import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';

interface ImpersonationStatus {
  impersonating: boolean;
  admin?: { id: string; email: string; name: string };
  user?: { id: string; email: string; name: string };
}

export function ImpersonationBanner() {
  const [status, setStatus] = useState<ImpersonationStatus | null>(null);
  const [stopping, setStopping] = useState(false);
  const router = useRouter();

  useEffect(() => {
    checkImpersonationStatus();
  }, []);

  const checkImpersonationStatus = async () => {
    try {
      const res = await fetch('/api/admin/impersonate');
      if (res.ok) {
        const data = await res.json();
        setStatus(data);
      }
    } catch (error) {
      console.error('Failed to check impersonation status:', error);
    }
  };

  const stopImpersonation = async () => {
    setStopping(true);
    try {
      const res = await fetch('/api/admin/impersonate', { method: 'DELETE' });
      if (res.ok) {
        setStatus({ impersonating: false });
        router.push('/admin/users');
        router.refresh();
      }
    } catch (error) {
      console.error('Failed to stop impersonation:', error);
    } finally {
      setStopping(false);
    }
  };

  if (!status?.impersonating) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        backgroundColor: '#f97316',
        color: 'white',
        padding: '6px 16px',
        fontSize: '13px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
      }}
    >
      <span>
        Viewing as <strong>{status.user?.name}</strong> ({status.user?.email})
      </span>
      <button
        onClick={stopImpersonation}
        disabled={stopping}
        style={{
          background: 'rgba(255,255,255,0.2)',
          border: '1px solid rgba(255,255,255,0.4)',
          color: 'white',
          padding: '2px 10px',
          borderRadius: '4px',
          fontSize: '12px',
          cursor: 'pointer',
        }}
      >
        {stopping ? '...' : 'Exit'}
      </button>
    </div>
  );
}
